import { UserReviewLoading } from '../UserReview/UserReviewLoading'
import styles from './ListLoading.module.css'

export function ListLoading() {
  const reviewLoadings = []
  for (let i = 0; i < 7; i++) {
    reviewLoadings.push(<UserReviewLoading key={i} />)
  }

  return <div className={styles.wrapper}>{reviewLoadings}</div>
}
